// extracted by mini-css-extract-plugin
export default {"main":"Clickard_main__Uk1z8","text":"Clickard_text__8yxrj","img":"Clickard_img__Wekwc"};